import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { differenceInHours, intervalToDuration, parseISO } from 'date-fns';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ScheduleDatePipe } from '@shared/pipes/schedule-date.pipe';
import { TachScheduleFileStatus } from '@src/app/enum/tacho.enum';
import { IGetVehicleTachographFileSchedule } from '@src/app/interfaces/api/files-ddd.interface';

@Component({
  selector: 'app-current-file-status-on-list',
  standalone: true,
  imports: [CommonModule, ScheduleDatePipe, TranslateModule],
  templateUrl: './current-file-status-on-list.component.html',
  styleUrls: ['./current-file-status-on-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrentFileStatusOnListComponent {
  private readonly translate = inject(TranslateService);

  @Input('data') set onChangeData(data: IGetVehicleTachographFileSchedule) {
    this._data = data;

    if (data.LastFileLoadDate) {
      const parseLastFileDate = parseISO(data.LastFileLoadDate);
      const diffHours = differenceInHours(new Date(), parseLastFileDate);

      if (diffHours <= 24) {
        const duration = intervalToDuration({ start: parseLastFileDate, end: new Date() });
        this.lastDownloadTimeAgo = diffHours < 1 ? `${ duration.minutes } ${this.translate.instant('minutesAgo')}` : `${ duration.hours }h ${duration.minutes} ${this.translate.instant('minutesAgo')}`;
        return;
      }
    }
    this.lastDownloadTimeAgo = null!;
  };

  public _data: IGetVehicleTachographFileSchedule;
  public lastDownloadTimeAgo: string = null!;
  public readonly TACHO_FILE_STATUS = TachScheduleFileStatus;
}
